/**
 * Admin section paths.
 *
 * Typed as `string` rather than literals on purpose: routes are registered dynamically
 * from the module registry, so TanStack Router's generated route union doesn't contain
 * them and the literal-typed `Link`/`navigate` overloads reject them. A `string` takes
 * the widened overload — the same idiom the quoting module uses for its own paths
 * (see packages/quoting/src/web/catalog-page.tsx).
 */
export const ACCESS_CONTROL_PATH: string = '/admin';
export const USERS_PATH: string = '/admin/users';

export const groupPath = (groupId: string): string =>
  `/admin/groups/${encodeURIComponent(groupId)}`;
export const userPath = (userId: string): string =>
  `/admin/users/${encodeURIComponent(userId)}`;
